import type {
  PendingQueryRun,
  PinnedSegment,
  RecentSegment,
  Segment,
} from './types'

type Keyable = Pick<Segment, 'id' | 'partner_segment_id'>

// Firm segments and partner segments share the numeric id space, so a stable
// row identity has to disambiguate the two. Keep every "segment key" in the
// overview going through here so the prefixes can never drift apart.
export const firmKey = (id: number): string => `s:${id}`
export const partnerKey = (id: number): string => `p:${id}`

export const segmentKey = (segment: Keyable): string =>
  segment.partner_segment_id
    ? partnerKey(segment.partner_segment_id)
    : firmKey(segment.id)

// The server emits exactly one id per row mirroring a SegmentRun (a recent
// segment, a pending run) or a PinnedSegment, so when partner_segment_id is
// absent segment_id is always present. The `?? 0` is an unreachable
// type-narrowing fallback: ids start at 1, so the resulting `s:0` simply never
// matches a real segment and the row drops out.
export const runKey = (
  run: RecentSegment | PendingQueryRun | PinnedSegment
): string =>
  run.partner_segment_id
    ? partnerKey(run.partner_segment_id)
    : firmKey(run.segment_id ?? 0)
